module.exports = __webpack_public_path__ + "static/media/metamask.a0103549.svg";